import { Sport } from '__generated__/globalTypes';
import { useConfigContext } from 'contexts/config';
import { useSportContext } from 'contexts/sport';

export default (leagueFilter: string | undefined) => {
  const { sport = Sport.FOOTBALL } = useSportContext();
  const {
    so5: {
      footballLeaguesAlgoliaFilters,
      baseballLeaguesAlgoliaFilters,
      nbaLeaguesAlgoliaFilters,
    },
  } = useConfigContext();
  const leagueFilterValue = {
    [Sport.FOOTBALL]: footballLeaguesAlgoliaFilters,
    [Sport.BASEBALL]: baseballLeaguesAlgoliaFilters,
    [Sport.NBA]: nbaLeaguesAlgoliaFilters,
  }[sport];

  if (!leagueFilter || !leagueFilterValue) return null;

  return leagueFilterValue[leagueFilter];
};
